import axios from 'axios';
import api from '../../services/api';
import ResponseError, { ErrorCode } from '../../types/response/ResponseError';
import { CancelTokenSource } from 'axios';
import { PagingResponseData } from '../../types/response/PagingResponseData';
import { Log } from '../../types/log/Log';

export const searchLogs = async (
    searchQueryString: string | undefined,
    searchStarted: (phrase: string, cancelToken: CancelTokenSource) => void,
    searchSucceeded: (data: PagingResponseData<Log[]>) => void,
    searchFailed: (error: ResponseError) => void,
    searchCanceled: () => void,
    organizationId?: string
) => {
    const source = axios.CancelToken.source();
    let query = searchQueryString?.replace('%252C%2520', '');
    if (query === '') query = 'query=&page=1&perPage=30';
    query = `?${query}`;

    if (organizationId) query += `&organizationId=${organizationId}`;

    searchStarted(query, source);

    try {
        const response = await api.get<PagingResponseData<Log[]>>(`logs${query}`, source.token);

        searchSucceeded(response);
    } catch (error) {
        const parsedError = error as ResponseError;

        if (parsedError.code === ErrorCode.CLIENT_CANCELED_ERROR) {
            searchCanceled();
        } else {
            searchFailed(error as ResponseError);
        }
    }
};
